const PRODUCT_QUERY_PREFIX = 'product';
export const PRODUCT_QUERY_KEY = {
	ROOT:        () => [ PRODUCT_QUERY_PREFIX ],
	GET_BY_SLUG: (slug: string) => [ PRODUCT_QUERY_PREFIX, 'detail', slug ],
	LIST:        (query: Record<string, unknown>) => [ PRODUCT_QUERY_PREFIX, 'list', query ],
	SUGGESTION:  (search: string) => [ PRODUCT_QUERY_PREFIX, 'suggestion', search ],
	FILTERS:     () => [ PRODUCT_QUERY_PREFIX, 'filters' ],
};